// Test Progress Action Types

// Save test progress
export const SAVE_TEST_PROGRESS_REQUEST = 'SAVE_TEST_PROGRESS_REQUEST';
export const SAVE_TEST_PROGRESS_SUCCESS = 'SAVE_TEST_PROGRESS_SUCCESS';
export const SAVE_TEST_PROGRESS_FAILURE = 'SAVE_TEST_PROGRESS_FAILURE';

// Fetch all tests
export const FETCH_TESTS_REQUEST = 'FETCH_TESTS_REQUEST';
export const FETCH_TESTS_SUCCESS = 'FETCH_TESTS_SUCCESS';
export const FETCH_TESTS_FAILURE = 'FETCH_TESTS_FAILURE';

// Fetch single test
export const FETCH_TEST_REQUEST = 'FETCH_TEST_REQUEST';
export const FETCH_TEST_SUCCESS = 'FETCH_TEST_SUCCESS';
export const FETCH_TEST_FAILURE = 'FETCH_TEST_FAILURE';

// Delete test
export const DELETE_TEST_REQUEST = 'DELETE_TEST_REQUEST';
export const DELETE_TEST_SUCCESS = 'DELETE_TEST_SUCCESS';
export const DELETE_TEST_FAILURE = 'DELETE_TEST_FAILURE';

// Update test (mark as complete, update score, etc.)
export const UPDATE_TEST_REQUEST = 'UPDATE_TEST_REQUEST';
export const UPDATE_TEST_SUCCESS = 'UPDATE_TEST_SUCCESS';
export const UPDATE_TEST_FAILURE = 'UPDATE_TEST_FAILURE';

// Fetch user answer history (aggregated from all completed tests)
export const FETCH_USER_ANSWER_HISTORY_REQUEST = 'FETCH_USER_ANSWER_HISTORY_REQUEST';
export const FETCH_USER_ANSWER_HISTORY_SUCCESS = 'FETCH_USER_ANSWER_HISTORY_SUCCESS';
export const FETCH_USER_ANSWER_HISTORY_FAILURE = 'FETCH_USER_ANSWER_HISTORY_FAILURE';

// Fetch user performance (cached backend)
export const FETCH_USER_PERFORMANCE_REQUEST = 'FETCH_USER_PERFORMANCE_REQUEST';
export const FETCH_USER_PERFORMANCE_SUCCESS = 'FETCH_USER_PERFORMANCE_SUCCESS';
export const FETCH_USER_PERFORMANCE_FAILURE = 'FETCH_USER_PERFORMANCE_FAILURE';

// Clear current test (to prevent stale data when switching tests)
export const CLEAR_CURRENT_TEST = 'CLEAR_CURRENT_TEST';
